import React from 'react';
import ColorForm from './components/ColorForm';

const CreateColor = () => {
  return <ColorForm/>;
};

export default CreateColor;
